"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginECR = exports.loginStandard = exports.logout = exports.login = void 0;
const aws = __importStar(require("./aws"));
const core = __importStar(require("@actions/core"));
const exec_1 = require("@docker/actions-toolkit/lib/exec");
function login(registry, username, password, ecr) {
    return __awaiter(this, void 0, void 0, function* () {
        if (/true/i.test(ecr) || (ecr == 'auto' && aws.isECR(registry))) {
            yield loginECR(registry, username, password);
        }
        else {
            yield loginStandard(registry, username, password);
        }
    });
}
exports.login = login;
function logout(registry) {
    return __awaiter(this, void 0, void 0, function* () {
        yield exec_1.Exec.getExecOutput('docker', ['logout', registry], {
            ignoreReturnCode: true
        }).then(res => {
            if (res.stderr.length > 0 && res.exitCode != 0) {
                core.warning(res.stderr.trim());
            }
        });
    });
}
exports.logout = logout;
function loginStandard(registry, username, password) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!username || !password) {
            throw new Error('Username and password required');
        }
        const loginArgs = ['login', '--password-stdin'];
        loginArgs.push('--username', username);
        loginArgs.push(registry);
        if (registry) {
            core.info(`Logging into ${registry}...`);
        }
        else {
            core.info(`Logging into Docker Hub...`);
        }
        yield exec_1.Exec.getExecOutput('docker', loginArgs, {
            ignoreReturnCode: true,
            silent: true,
            input: Buffer.from(password)
        }).then(res => {
            if (res.stderr.length > 0 && res.exitCode != 0) {
                throw new Error(res.stderr.trim());
            }
            core.info(`Login Succeeded!`);
        });
    });
}
exports.loginStandard = loginStandard;
function loginECR(registry, username, password) {
    return __awaiter(this, void 0, void 0, function* () {
        core.info(`Retrieving registries data through AWS SDK...`);
        const regDatas = yield aws.getRegistriesData(registry, username, password);
        for (const regData of regDatas) {
            core.info(`Logging into ${regData.registry}...`);
            yield exec_1.Exec.getExecOutput('docker', ['login', '--password-stdin', '--username', regData.username, regData.registry], {
                ignoreReturnCode: true,
                silent: true,
                input: Buffer.from(regData.password)
            }).then(res => {
                if (res.stderr.length > 0 && res.exitCode != 0) {
                    throw new Error(res.stderr.trim());
                }
                core.info('Login Succeeded!');
            });
        }
    });
}
exports.loginECR = loginECR;
